<script setup lang="ts">
    import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import { EmployeeOptional } from '@/types';
    import { usePermissions } from '@/composables/usePermissions';
    import Permission from '@/enums/Permission';
    import EditEmployeeOptional from '@/components/employee-optionals/EditEmployeeOptional.vue';

    defineProps<{
        employeeOptional: EmployeeOptional;
    }>();

    const { hasPermission } = usePermissions();
</script>

<template>
    <DataTableActions
        v-if="hasPermission(Permission.SALARY_COMPANY_UPDATE)"
        :data="employeeOptional"
    >
        <EditEmployeeOptional :employee-optional="employeeOptional" />
    </DataTableActions>
</template>
